import { AuthorizationAPI } from '@newo/api/gateway';
import useAppStore from '@/store/app.ts';
import { privateAxiosInstance, publicAxiosInstance } from '@/libs/axios';

const authApi = new AuthorizationAPI(publicAxiosInstance);

const SECOND_IN_MS = 1000;
const DEFAULT_TIMESTAMP = 0;

class RefreshTokenSingleton {
    private static instance?: RefreshTokenSingleton;

    public isPending = false;

    public static getInstance(): RefreshTokenSingleton {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        if (!RefreshTokenSingleton.instance) {
            RefreshTokenSingleton.instance = new RefreshTokenSingleton();
        }
        return RefreshTokenSingleton.instance;
    }

    constructor() {
        this.isPending = false;
    }

    public async refreshToken() {
        const now = Date.now();
        const lastTimeUpdateAt =
            useAppStore.getState().lastTimeUpdateAt ?? DEFAULT_TIMESTAMP;
        if (!this.isPending && now - lastTimeUpdateAt > SECOND_IN_MS) {
            this.isPending = true;
            try {
                const refreshToken = useAppStore.getState().refreshToken ?? '';
                const data = await authApi.refreshTokenPair({
                    refresh_token: refreshToken
                });
                privateAxiosInstance.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
                useAppStore
                    .getState()
                    .setTokens(
                        data.access_token,
                        data.refresh_token,
                        data.expires_in
                    );
            } finally {
                this.isPending = false;
            }
        }
    }
}

const instance = RefreshTokenSingleton.getInstance();

export default instance;
